import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from 'src/util/axios-instance';
import {
  FetchDynamicLinksRequestParams,
  FetchDynamicLinksResponseData
} from './interfaces/fetchDynamicLinks.interface';

export const fetchDynamicLinks = async (
  params: FetchDynamicLinksRequestParams
): Promise<FetchDynamicLinksResponseData | undefined> => {
  const { onlyCreatedFromAdmin, projectId } = params;

  const response = await api.get<FetchDynamicLinksResponseData>(
    `${API_URL}/v1/project/${projectId}/dynamicLinks?${
      onlyCreatedFromAdmin ? 'onlyCreatedFromAdmin=true' : ''
    }`,
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};
